/* eslint-disable */
import React, { Component } from 'react';
import { usePromiseTracker } from "react-promise-tracker";
import 'react-responsive-modal/styles.css';
import { MetroSpinner } from "react-spinners-kit";
import Dialog from '@material-ui/core/Dialog';


export const LoadingComponent = (props) => {
  const { promiseInProgress } = usePromiseTracker();

  return (
    <Dialog
      open={promiseInProgress}
      style={{ background: "transparent" }}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflowX: "hidden",
          overflowY: "hidden"
        },
      }}>
      <MetroSpinner
        size={80}
        color="#139a43"
        open={promiseInProgress}
        onClose={promiseInProgress}
      />
    </Dialog>
  );

};
